/* Sui Story — product-card image carousel.
   Mobile: each card is a horizontal scroll-snap swiper; this keeps the dot
   indicator in sync with the swiped image. Desktop uses a CSS hover-slide,
   so this only matters on touch. Re-runs on page init (and Barba nav). */
(function () {
  'use strict';
  var S = (window.SuiStory = window.SuiStory || {});

  function setActive(carousel) {
    var dots = carousel.parentElement && carousel.parentElement.querySelector('[data-card-dots]');
    if (!dots) return;
    var w = carousel.clientWidth || 1;
    var idx = Math.round(carousel.scrollLeft / w);
    var ds = dots.children, n = ds.length;
    if (idx < 0) idx = 0;
    if (idx > n - 1) idx = n - 1;
    for (var i = 0; i < n; i++) ds[i].classList.toggle('is-active', i === idx);
  }

  function wire(carousel) {
    if (carousel.__cardCarousel) return;
    carousel.__cardCarousel = true;
    var raf = 0;
    carousel.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; setActive(carousel); });
    }, { passive: true });
  }

  function init(scope) {
    var els = (scope || document).querySelectorAll('[data-card-carousel]');
    Array.prototype.forEach.call(els, wire);
  }
  S.initCardCarousels = init;

  document.addEventListener('suistory:page:init', function (e) {
    init(e.detail && e.detail.scope);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
